import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import DocumentUploadedConfirmApiRequest from "../request/DocumentUploadedConfirmApiRequest";

const ConfirmDocumentUploaded = async ({
  jobId,
  succeeded,
}: DocumentUploadedConfirmApiRequest): Promise<boolean> => {
  const url = `/document_processing_jobs/${jobId}/upload_confirmed/`;
  const { data } = await axios.put(url, { succeeded });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useConfirmDocumentUploaded = () =>
  useMutation<boolean, AxiosError, DocumentUploadedConfirmApiRequest>(
    ConfirmDocumentUploaded,
    {
      mutationKey: ["ConfirmDocumentUploaded"],
    }
  );

export default useConfirmDocumentUploaded;
